import { render } from "./detectorReport.vue?vue&type=template&id=0c01f822&scoped=true"
import script from "./detectorReport.vue?vue&type=script&lang=js"
export * from "./detectorReport.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=0c01f822&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wjlfi\\Desktop\\1v1vue3\\demos\\basic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c01f822"]])

export default __exports__